"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDispatchToProps = void 0;
var connected_react_router_1 = require("connected-react-router");
var AuthActions = require("@caddigital/sok-reducers/lib/actions/auth/current");
var customerActions = require("@caddigital/sok-reducers/lib/actions/firstLogin/customer");
var FirstLoginActions = require("@caddigital/sok-reducers/lib/actions/firstLogin/form");
var translations_1 = require("@caddigital/sok-reducers/lib/actions/translations");
var mapDispatchToProps = function (dispatch) { return ({
    toggleModal: function () { return dispatch(customerActions.toggleNewCustomerModal()); },
    changePage: function (page) { return function () {
        return dispatch(FirstLoginActions.changeStep(page));
    }; },
    selectUserAvatar: function (iconString) {
        return dispatch(FirstLoginActions.setUserAvatar(iconString));
    },
    hasAcceptedTerms: function (hasAcceptedTerms) { return function () {
        return dispatch(FirstLoginActions.changeAcceptTerms(hasAcceptedTerms));
    }; },
    acceptMarketingConsent: function (hasAcceptedMarketingConsent) { return function () {
        return dispatch(FirstLoginActions.acceptMarketingConsent(hasAcceptedMarketingConsent));
    }; },
    updateField: function (key) { return function (value) {
        return dispatch(FirstLoginActions.updateField(key, value));
    }; },
    setLanguage: function (language) {
        dispatch(FirstLoginActions.updateField('language', language));
    },
    fetchLanguage: function (language) { return dispatch((0, translations_1.fetchLanguageRequest)(language)); },
    setCountry: function (selectedOption) {
        return dispatch(FirstLoginActions.updateField('country', selectedOption.code));
    },
    setExistCustomer: function (customer) { return (dispatch(FirstLoginActions.setCompany(customer.id)),
        customer.addressDetails &&
            dispatch(FirstLoginActions.updateField('street', customer.addressDetails.street || '')),
        customer.addressDetails &&
            dispatch(FirstLoginActions.updateField('country', customer.addressDetails.country || '')),
        customer.addressDetails &&
            dispatch(FirstLoginActions.updateField('postalCode', customer.addressDetails.postalCode || '')),
        customer.addressDetails &&
            dispatch(FirstLoginActions.updateField('city', customer.addressDetails.city || ''))); },
    setCustomerSearchString: function (searchString) { return (searchString &&
        dispatch(customerActions.setCustomerSearchString(searchString)),
        searchString &&
            dispatch(customerActions.searchCustomerRequest(searchString))); },
    submitFirstTimeLogin: function (iconString, userData, hasAcceptedTerms, termsVersion, companyId) {
        return function () {
            var firstTimeUser = userData;
            if (companyId !== null && !Number.isNaN(companyId)) {
                firstTimeUser.company = companyId;
            }
            else {
                firstTimeUser.company = undefined;
            }
            return dispatch(FirstLoginActions.SubmitFirstLoginRequest(__assign(__assign({}, firstTimeUser), { avatar: iconString, hasAcceptedTerms: hasAcceptedTerms, termsVersion: termsVersion })));
        };
    },
    fetchRegions: function () { return dispatch(FirstLoginActions.fetchRegionsRequest()); },
    fetchUser: function () { return dispatch(AuthActions.getUserinfoRequestAction()); },
    returnToApp: function () { return dispatch((0, connected_react_router_1.replace)('/')); },
    shouldRedirectToTerms: function () {
        return dispatch(FirstLoginActions.shouldRedirectUserToTermsPage());
    }
}); };
exports.mapDispatchToProps = mapDispatchToProps;
